module.exports = __webpack_public_path__ + "static/media/lt_truck_end.cb41f084.png";